import {
    Component,
    Input,
    ViewChild,
    ViewChildren,
    EventEmitter,
    Output, OnInit,
} from '@angular/core';
import {MatSelectionList, MatListOption} from '@angular/material/list';
import {IApiPagingOutput} from 'libraries/service/resources/IApiPagingOutput';
import {PermissionResourceService} from "libraries/service/resources/permission/permissionResource.service";

import {Yii} from "libraries/interfaces/Yii";
import {MatCheckboxChange} from '@angular/material/checkbox';
import {ProcessingType} from 'libraries/service/processing/processing.service';
import {ILabels} from 'libraries/interfaces/ILabels';
import {IGetBookingsCommonResponse} from 'libraries/service/resources/booking/interfaces/IGetBookings';
import {IBookingSearchResultConfig} from "libraries/interfaces/IConfigurableTable";
import { BookingListDomainService } from "libraries/service/booking-list-domain/booking-list-domain.service";

@Component({
    selector: 'bookings-list',
    templateUrl: './booking-list.component.html',
    styleUrls: [
        '../../../../../styles/angular-material/checkbox.scss',
        '../../../../../styles/angular-material/pseudo-checkbox.scss',
        '../../../../../styles/angular-material/list-option.scss',
        '../../../../../styles/angular-material/selection-list.scss',
    ],
    styles: [`
        mat-selection-list.mat-selection-list header.header {
            display: flex;
            padding: .75rem 7px;
            align-items: center;
        }

        header > mat-checkbox.mat-checkbox {
            margin: 0 10px 0 0;
        }

        .space-left {
            margin-left: 10px;
        }

        ::ng-deep mat-pseudo-checkbox.mat-pseudo-checkbox {
            margin: 3px 0 0 0;
        }

        ::ng-deep mat-pseudo-checkbox.mat-pseudo-checkbox-disabled {
            opacity: 0;
        }

        .btn-csv {
            margin-left: 20px;
        }
    `]
})
export class BookingsListComponent implements OnInit{

    /////////// COMPONENT VARIABLES

    @ViewChild('selectionListBookings')
    public selectionListBookings: MatSelectionList;

    @ViewChildren('listOptionBooking')
    public listOptionBooking: MatListOption;

    @Input()
    public selectable: boolean = true;

    //@Input()
    //public readonly exportNotification: INotification;

    @Input()
    public canFilter: boolean = true;

    @Input()
    public canExportExcel: boolean = true;

    @Input()
    public bookings: IGetBookingsCommonResponse[];

    @Input()
    public recordset: IApiPagingOutput;

    @Input()
    public selectedOptions: IGetBookingsCommonResponse[] = [];

    @Output()
    public readonly onSelect: EventEmitter<IGetBookingsCommonResponse[]> = new EventEmitter();

    @Output()
    public readonly onAction: EventEmitter<string> = new EventEmitter();

    public checkboxPosition: string = 'before';
    public labels: ILabels = {
        selectAll: Yii.t('wui-sasha-js', 'Sélectionner les résultats'),
        selectionFilter: Yii.t('wui-sasha-js', 'Filtrer sur la selection'),
        exportExcel: Yii.t('wui-sasha-js', 'Export Excel'),
    };

    public filterThisSelection: boolean = false;
    public processingType: ProcessingType;
    public checked: boolean = false;
    public bookingSearchConfig: IBookingSearchResultConfig;

    /////////// Lifecycle

    constructor(
        private readonly permissionService: PermissionResourceService,
        private readonly bookingListDomainService: BookingListDomainService,
    ) {
    }

    /////////// COMPONENT FUNCTIONS
    public ngOnInit(): void {
        this.getConfigurableTableConfig();
    }

    public onChangeSelect(event: MatCheckboxChange): void {
        event.checked ?
            this.selectionListBookings.selectAll() :
            this.selectionListBookings.deselectAll();
        this.getBookingSelection();
    }

    public getBookingId(booking: IGetBookingsCommonResponse): string {
        return booking.code;
    }

    public getBookingSelection(): void {
        this.onSelect.emit(this.selectedOptions);
    }

    public storeSelection(event: IGetBookingsCommonResponse[]): void {
        this.selectedOptions = event;
        this.onSelect.emit(this.selectedOptions);
    }


    public action(treatmentName: string): void {
        this.onAction.emit(treatmentName);
    }

    public getSelectionRange(): string {
        const selectAll: string = this.labels.selectAll;
        const to: string = Yii.t('wui-sasha-js', 'à');

        if (this.recordset) {
            const first: number = this.recordset.first;
            const total: number = this.recordset.total;
            const last: number = Math.max(0, Math.min(total, this.recordset.first + this.recordset.nbrecord - 1));
            return `${selectAll} ${first} ${to} ${last} / ${total}`;
        } else {
            return `${selectAll} 1 ${to} ${this.bookings.length} / ${this.bookings.length}`;
        }

    }

    public selectOnlyEnabledOptions() {
        // §TODO : EJ+2018-08-24 : find a way to select all Options BUT NOT disabled ones
        // this fn will replace
        /*
            this.selectionListBookings.selectAll() :
            this.selectionListBookings.deselectAll();
         */
        // in onChangeSelect()
    }

    public focus(): void {
        this.selectionListBookings.focus();
    }

    private getConfigurableTableConfig(): void {
        this.bookingListDomainService.getTableConfiguration().subscribe((config: IBookingSearchResultConfig): void => {
            this.bookingSearchConfig = config;
        });
    }

}
